(() => {
  let unsubscribeVariantChange = null;
  let stickyObserver = null;

  const hydrate = () => {
    const productInfo = document.querySelector('product-info');
    if (!productInfo || productInfo.dataset.epProductInteractionsInitialized === 'true') return;

    const sectionId = productInfo.dataset.section;
    if (!sectionId) return;

    const variantDataElement = document.getElementById(`EpProductVariants-${sectionId}`);
    if (!variantDataElement) return;

    let variants = [];
    try {
      variants = JSON.parse(variantDataElement.textContent || '[]');
    } catch (error) {
      console.error('ExcelPack: unable to parse variant payload', error);
      return;
    }

    if (!Array.isArray(variants) || variants.length === 0) return;

    productInfo.dataset.epProductInteractionsInitialized = 'true';

    const findVariant = (id) => variants.find((variant) => String(variant.id) === String(id));

    const productForm = document.querySelector(`#product-form-${sectionId}`);
    const variantInput = productForm?.querySelector('input[name="id"]');
    let currentVariant = findVariant(variantInput?.value);

    const stickyAtc = document.getElementById('ep-sticky-atc');
    const stickyButton = stickyAtc?.querySelector('[data-ep-sticky-button]');
    const stickyPrice = stickyAtc?.querySelector('[data-ep-sticky-price]');
    const stickyImage = stickyAtc?.querySelector('[data-ep-sticky-image]');
    const stickyTitle = stickyAtc?.querySelector('.ep-sticky-atc__title');
    const stickyAddLabel = stickyAtc?.dataset.addLabel || stickyButton?.textContent?.trim() || '';
    const stickySoldOutLabel = stickyAtc?.dataset.soldOutLabel || stickyAddLabel;
    const mainSubmitButton = productForm?.querySelector('.product-form__submit');

    const basePrice = document.getElementById('ep-base-price');
    const totalPrice = document.getElementById('ep-total-price');
    const variantDetails = document.getElementById('ep-variant-details');
    const personalizationLine = document.getElementById('ep-personalization-line');
    const personalizationPrice = document.getElementById('ep-personalization-price');

    const updateStickySection = (variant) => {
      if (!stickyAtc || !variant) return;

      if (stickyPrice) {
        stickyPrice.textContent = variant.price;
      }

      if (stickyImage && variant.image?.src) {
        stickyImage.src = variant.image.src;
        if (variant.image.alt) {
          stickyImage.alt = variant.image.alt;
        }
      }

      if (stickyButton) {
        const isAvailable = Boolean(variant.available);
        stickyButton.disabled = !isAvailable;
        stickyButton.textContent = isAvailable ? stickyAddLabel : stickySoldOutLabel;
        stickyAtc.classList.toggle('ep-sticky-atc--disabled', !isAvailable);
      }

      if (stickyTitle) {
        stickyTitle.setAttribute('aria-live', 'polite');
      }
    };

    const updatePricingBreakdown = (variant) => {
      if (!variant) return;

      if (basePrice) {
        basePrice.textContent = variant.price;
      }

      if (totalPrice) {
        totalPrice.textContent = variant.price;
      }

      if (variantDetails) {
        variantDetails.textContent = variant.title === 'Default Title' ? (stickyTitle?.textContent || '') : variant.title;
      }

      if (personalizationLine && personalizationPrice) {
        personalizationLine.hidden = true;
        personalizationPrice.textContent = '0.00';
      }
    };

    stickyObserver?.disconnect();
    stickyObserver = null;

    if (stickyAtc && stickyButton && mainSubmitButton) {
      let isButtonVisible = false;
      let isFooterVisible = false;

      // Observer pour le bouton principal
      const buttonObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isButtonVisible = entry.isIntersecting;
            // Afficher le sticky seulement si le bouton n'est pas visible ET le footer n'est pas visible
            if (isButtonVisible || isFooterVisible) {
              stickyAtc.classList.remove('is-visible');
            } else {
              stickyAtc.classList.add('is-visible');
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '-80px 0px 0px 0px',
        }
      );

      // Observer pour le footer
      const footer = document.querySelector('.shopify-section-group-footer-group, footer, [data-section-type="footer"]');
      if (footer) {
        const footerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              isFooterVisible = entry.isIntersecting;
              // Masquer le sticky si le footer est visible
              if (isFooterVisible) {
                stickyAtc.classList.remove('is-visible');
              } else if (!isButtonVisible) {
                stickyAtc.classList.add('is-visible');
              }
            });
          },
          {
            threshold: 0,
            rootMargin: '0px 0px 200px 0px', // Commence à masquer 200px avant le footer
          }
        );

        footerObserver.observe(footer);
      }

      buttonObserver.observe(mainSubmitButton);
      stickyObserver = buttonObserver; // Keep reference for cleanup

      stickyButton.addEventListener('click', () => {
        if (!stickyButton.disabled) {
          mainSubmitButton.click();
        }
      });
    }

    const handleVariantChange = (variantPayload) => {
      const variant = findVariant(variantPayload?.id ?? variantPayload);
      if (!variant) return;
      currentVariant = variant;
      updateStickySection(variant);
      updatePricingBreakdown(variant);
    };

    if (currentVariant) {
      updateStickySection(currentVariant);
      updatePricingBreakdown(currentVariant);
    }

    unsubscribeVariantChange?.();
    unsubscribeVariantChange = null;

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      unsubscribeVariantChange = window.subscribe(window.PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.sectionId !== sectionId) return;
        handleVariantChange(data.variant || data.variantId);
      });
    } else {
      productForm?.addEventListener('change', () => {
        const updated = findVariant(variantInput?.value);
        if (updated && updated !== currentVariant) {
          handleVariantChange(updated);
        }
      });
    }
  };

  document.addEventListener('product-info:loaded', hydrate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
